export const getIdFromFieldName = (fieldName: string[]): string =>
  fieldName.join('_')
